export default __webpack_public_path__ + "static/media/express.7d023c32.svg";